import { colors } from 'ui/theme';
import { CustomNode } from '../../../types';

export const CONTACT_ACTION_ACCENT_COLOR = colors.green50;
export const CONTACT_ACTION_BACKGROUND_ACCENT_COLOR = colors.green50;
export const CONTACT_ACTION_BORDER_ACCENT_COLOR = colors.green50;
export const CONTACT_ACTION_DEFAULT_TITLE = 'Contact Action';

export const contactActionBaseConfig: CustomNode = {
  getCustomConfig(model) {
    return {
      defaultTitle: CONTACT_ACTION_DEFAULT_TITLE,
      accentColor: CONTACT_ACTION_ACCENT_COLOR,
      activeBorderColor: CONTACT_ACTION_BORDER_ACCENT_COLOR,
      accentColorBackground: CONTACT_ACTION_BACKGROUND_ACCENT_COLOR,
      ...this.getNodeConfig(model),
    };
  },

  getNodeConfig() {
    return {};
  },
};
